import React from "react";
import { Car, Language } from "../../types";
import { useNavigate } from "react-router-dom";
import { useContextProvider } from "../../context";
import { getCarUrl } from "../../utilities";
import { CarDetails } from "../shared/carDetails";
import "./index.css";
import { trackEvent } from "../../utilities/tracking";

interface CarPreviewProps {
  car: Car;
}

const dict = {
  [Language.English]: {
    details: "Details",
  },
  [Language.Spanish]: {
    details: "Detalles",
  },
  [Language.Russian]: {
    details: "Подробности",
  },
  [Language.Ukrainian]: {
    details: "Деталі",
  },
};

export const CarPreview: React.FC<CarPreviewProps> = ({ car }) => {
  const navigate = useNavigate();
  const { language } = useContextProvider();

  const { details } = dict[language];

  const handleClick = () => {
    const carUrl = getCarUrl(car);
    navigate(`/car/${carUrl}`);
    trackEvent("car_details_button_clicked", {
      event_category: "car",
      event_label: carUrl,
    });
  };

  return (
    <article className="CarPreview">
      <CarDetails car={car} language={language} />

      <button
        className="CarPreview-detailsButton"
        onClick={handleClick}
        aria-label={details}
        title={details}
      >
        {details}
      </button>
    </article>
  );
};
